<template>
  <div id="gaoBaoBanSwitchAccountDialogRoot">
    <div id="gaoBaoBanSwitchAccountDialogContainer">
      <div style="flex:8;display: flex;justify-content: center;align-items: center;font-size: x-small;">
      是否退出当前账号
      </div>
      <div style="width: 100%;height:1px;background-color:gray;"></div>
      <div style="flex:2;display: flex;justify-content: center;align-items: center;flex-direction: row;">
        <div style="flex: 1;display:flex;justify-content:center;align-items:center;color:black;font-size: x-small;" @click="cancelDialog()">取消</div>
        <div style="height: 50%;width:1px;background-color:gray;"></div>
        <div :style="{'color':$store.state.baseColor}" style="flex: 1;display:flex;justify-content:center;align-items:center;font-size: x-small;" @click="switchEnsure()">切换</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    components: {
    },
    methods:{
      // 隐藏提示页面
      cancelDialog(){
        this.$emit("closedialog");
      },
      switchEnsure(){
        this.$emit("logoutensure");
        this.sendToClient('logout?')
      },
    },
  }
 </script>

<style>
  #gaoBaoBanSwitchAccountDialogRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(51,51,51,0.5);
    z-index: 2233;
  }
  #gaoBaoBanSwitchAccountDialogContainer{
    width:280px;
    height:200px; 
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 2255;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }

</style>


// WEBPACK FOOTER //
// src/views/GaoBaoBan/userCenter/SwitchAccountDialog.vue